/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiFeedbacksQueryResponse, GetApiFeedbacksQueryParams, GetApiFeedbacks400, GetApiFeedbacks401, GetApiFeedbacks403, GetApiFeedbacks500 } from "../../types/GetApiFeedbacks.ts";
import { getApiFeedbacksQueryResponseSchema } from "../../zod/FeedbackSchemas/getApiFeedbacksSchema.ts";

function getGetApiFeedbacksUrl() {
  const res = { method: 'GET', url: `/api/feedbacks` as const }  
  return res
}

/**
 * @summary Получить список чатов
 * {@link /api/feedbacks}
 */
export async function getApiFeedbacks({ params }: { params?: GetApiFeedbacksQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiFeedbacksQueryResponse, ResponseErrorConfig<GetApiFeedbacks400 | GetApiFeedbacks401 | GetApiFeedbacks403 | GetApiFeedbacks500>, unknown>({ method : "GET", url : getGetApiFeedbacksUrl().url.toString(), params, ... requestConfig })  
  return getApiFeedbacksQueryResponseSchema.parse(res.data)
}